<template>
  <DetailView
    :show.sync="show"
    :config="{
      title: '交付物详情查看'
    }"
  >
    <DetailCard title="基本信息">
      <DescView :descLabels="descLabels1" :descDatas="detail">
        <template #userName>{{ detail.userName || '无' }}<WpView v-if="detail.userName" :id="detail.peopleId" :type="0" /></template>
        <template #mobile>{{ detail.mobile || '无' }}<WpView v-if="detail.mobile" :id="detail.peopleId" :type="0" /></template>
        <template #idCard>{{ detail.idCard || '无' }}<WpView v-if="detail.idCard" :id="detail.peopleId" :type="0" /></template>
      </DescView>
    </DetailCard>
    <DetailCard title="交付物">
      <DescView :descLabels="descLabels2" :descDatas="detail">
        <template #deliverableState>{{ detail.deliverableState || '无' }}</template>
        <template #updateState>{{ detail.updateState || '无' }}</template>
      </DescView>
    </DetailCard>
    <DetailCard title="上传记录">
      <el-table :data="operationDetails" style="width: 100%">
        <el-table-column type="index" width="50" label="#"> </el-table-column>
        <el-table-column prop="operationType" label="上传类型"> </el-table-column>
        <el-table-column prop="operationTime" label="记录时间"> </el-table-column>
        <el-table-column prop="updateTime" label="上传时间"> </el-table-column>
        <el-table-column prop="operationDesc" label="交付物描述"> </el-table-column>
        <el-table-column label="发票图片">
          <template slot-scope="{ row }">
            <ImageViewer v-if="row.updateUrl" :path="row.updateUrl" />
          </template>
        </el-table-column>
      </el-table>
    </DetailCard>
  </DetailView>
</template>

<script>
import { kvAuditStatus } from '@/configs/formatters'
import ImageViewer from '@/components/tableView/imageViewer'
import WpView from '@/components/wpView'
import { downloadUrl } from '@/utils'
import { tableDeliverableOperation } from '@/configs/tables.js'
const descLabels1 = [
  { label: '创客姓名', cmp: 'slot', slotName: 'userName' },
  { label: '手机号', cmp: 'slot', slotName: 'mobile' },
  { label: '身份证号', cmp: 'slot', slotName: 'idCard' }
]
const descLabels2 = [
  { label: '状态', prop: 'deliverableState' },
  { label: '上传状态', prop: 'updateState' },
]
export default {
  components: { ImageViewer, WpView },
  data() {
    return {
      show: false,
      labels: tableDeliverableOperation,
      id: null,
      descLabels1,
      descLabels2,
      detail: {},
      operationDetails: [],
      isEdit: false
    }
  },
  methods: {
    viewPdf(e) {
      downloadUrl(e)
    },
    async open(obj) {
      const result = await this.$api.GetSupplierPeopleDeliverableOperationPageList({ Id: obj.id });
      console.log("result",result);
      this.operationDetails = result.list;
      this.detail = obj;
      this.show = true
    }
  }
}
</script>

<style lang="scss" scoped>
.otherStyle {
  color: #3d78fa;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  &:hover {
    text-decoration: underline;
  }
}
</style>
